module.exports = __webpack_public_path__ + "img/x.4b564f76.svg";